import { render, staticRenderFns } from "./PublicRegistration.vue?vue&type=template&id=55b75b31&scoped=true&"
import script from "./PublicRegistration.vue?vue&type=script&lang=js&"
export * from "./PublicRegistration.vue?vue&type=script&lang=js&"
import style0 from "./PublicRegistration.vue?vue&type=style&index=0&id=55b75b31&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b75b31",
  null
  
)

export default component.exports
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QLayout,QPageContainer,QPageSticky,QBtn});
